'use client'

import React from 'react';
import { Home, User, Grid3X3, Phone, Info } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useLanguage } from '../contexts/LanguageContext'; // Adjust the path according to your file structure
import { FaInfoCircle } from "react-icons/fa";

const MobileBottomNavigation = () => {
  const pathname = usePathname(); // Current URL path
  const { t } = useLanguage(); // Using your custom language context

  const navItems = [
    {
      id: 'home',
      icon: Home,
      label: t.home || 'Home',
      href: '/'
    },
    {
      id: 'about',
      icon: Info,
      label: t.about || 'About',
      href: '/about'
    },
    {
      id: 'category',
      icon: Grid3X3,
      label: t.categories || 'Category',
      href: '/cattegory'
    },
    {
      id: 'contact',
      icon: Phone,
      label: t.contact || 'Contact',
      href: '/contact'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col">
      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white/10 backdrop-blur-md border-t border-white/20 z-50">
        <div className="max-w-md mx-auto px-4 py-3">
          <div className="flex items-center justify-around">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = pathname === item.href;

              return (
                <Link href={item.href} key={item.id}>
                  <div
                    className={`
                      flex flex-col items-center justify-center p-2 rounded-xl transition-all duration-300 cursor-pointer
                      ${isActive
                        ? 'text-red-500 scale-110'
                        : 'text-gray hover:text-white hover:scale-105'
                      }
                    `}
                  >
                    <Icon
                      size={24}
                      className={isActive ? 'text-red-500' : ''}
                    />
                    <span className={`text-xs mt-1 font-medium ${isActive ? 'text-red-500' : 'text-gray'}`}>
                      {item.label}
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileBottomNavigation;